import BasePageMixin from './BasePageMixin';

export default {
  mixins: [ BasePageMixin ],

  created() {
    this.onFindSuccess = this.onFindSuccess.bind(this);
    this.onFindError = this.onFindError.bind(this);
  },

  data() {
    return {
      filters: {},
      pageRequest: {
        number: 1, // Pagina 3
        size: 20, // 5 risultati per pagina
      },
      sort: null,
      page: {}
    };
  },

  mounted() {
    if (!this.doNotFindOnMounted) {
      this.find();
    } else {
      this.page = {};
      this.loading = false;
    }
  },

  methods: {
    find() {
      if (this.forceFilters) {
        this.forceFilters();
      }

      const parameters = this.filters;

      this.loading = true;
      this.service.find({
        parameters,
        pageRequest: this.pageRequest,
        sort: this.sort
      }).then(this.onFindSuccess, this.onFindError);
    },

    onFindSuccess({ statusCode, data}) {
      console.log('onFindSuccess', statusCode, data);
      this.page = data || {};
      this.loading = false;
    },

    onFindError({ statusCode, data }) {
      const key = 'onError' + statusCode;
      if (this[key]) {
        this[key]({ statusCode, data });
      } else {
        this.onAnyError({ statusCode, data });
      }
      this.loading = false;
    },

    selectPageSize(number) {
      console.log('selectPageSize', number);
      this.pageRequest.size = number;
      this.find();
    },

    selectPage(number) {
      this.pageRequest.number = number;
      this.find();
    },

    sortBy(item) {
      const page = this.page;

      // console.log('sortedBy', page && page.sortedBy);

      const path      = item.path;
      const queryPath = item.queryPath || path;

      // console.log('path', path);
      // console.log('queryPath', queryPath);

      let sort = null;
      let order = null;

      if (page && page.sortedBy === path) {
        // console.log('Same path -> Changing order');
        order = page.sortOrder && page.sortOrder.toUpperCase().startsWith('ASC')
            ? 'DESC'
            : 'ASC';
      } else {
        // console.log('New path');
        order = 'ASC';
      }

      // console.log('previous dir', page.sortOrder);
      // console.log('new dir', order);

      this.sort = {
        sort: queryPath,
        order
      };
      this.find();
    }
  }
};
